<template>
    <div class="row mb-3">
        <div class="col-md-6">
            <p>現在の時刻：<span v-text="currentTime"></span>&nbsp;開始時刻：<span v-text="startTime"></span>&nbsp;【経過時間：<span v-text="passedTime"></span>】</p>
            <h1><span class="small">担当医名：</span>&nbsp;{{ doctor.full_name }}&nbsp;<button type="button" @click="openDoctorProfileModal" class="btn btn-yokumiru-blue btn-sm">担当医プロフィール</button></h1>
            <doctor-profile-modal/>
        </div>
        <div class="col-md-6">

        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'doctor',
            'consultation',
        ],
        data: function() {
            return {
                currentTime: null,
                startTime: null,
                passedTime: '0',
            }
        },
        methods: {
            /**
             * 現在時刻の更新
             *
             * @return {void}
             */
            updateCurrentTime: function() {
                this.currentTime = moment().format('LTS');
                this.passedTime = moment().diff(moment(this.consultation.start_time), 'minutes') + '分';
            },

            /**
             * 担当医プロフィール表示
             *
             * @return {void}
             */
            openDoctorProfileModal: function() {
               bus.$emit( 'open-modal-doctor-profile', doctor.id );
            },
        },
        created: function() {
            // 開始時刻の設定
            this.startTime = moment(this.consultation.start_time).format('LTS');

            // 現在時刻の更新設定
            this.currentTime = moment().format('LTS');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
        }
    }
</script>

<style scoped>

</style>